// This component is used to enable / disable Smooth Curve option for Line charts

import { useDispatch, useSelector } from 'react-redux';
import { enableSmoothCurve } from '../../../redux/ChartPoperties/ChartControlsActions';
import SwitchWithInput from '../SwitchWithInput';
import { RootState } from '../../../redux';

const LineChartStyles = ({ iconColor }: { iconColor?: string }) => {
  const dispatch = useDispatch();

  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  const setSmoothCurve = (propKey: string, enable: boolean) => {
    dispatch(enableSmoothCurve(propKey, enable));
  };

  return (
    <div className="optionsInfo" style={{ overflowX: 'hidden' }}>
      <div
        className="optionDescription"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '0',
          marginTop: '0',
        }}
      >
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{ color: iconColor ? iconColor : '#404040' }}
        >
          Smooth Curve
        </label>

        <div
          style={{
            width: '50px',
            height: '24px',
            display: 'flex',
            transform: 'translateX(63px)',
            marginBottom: '9px',
          }}
        >
          <SwitchWithInput
            isChecked={chartControls.properties[propKey].smoothCurve?.enable}
            onSwitch={() => {
              setSmoothCurve(propKey, !chartControls.properties[propKey].smoothCurve?.enable);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LineChartStyles;
